function ReplaceUnicodeEscapes(str) {
  return str.replace(/\\u([\d\w]{4})/gi, function (match, grp) {
    return String.fromCharCode(parseInt(grp, 16));
  });
}

export default ReplaceUnicodeEscapes;
